import React, { useRef, useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";

import { SvgButtonArrowLeft } from "assets/icons/js/SvgButtonArrowLeft";
import { SvgButtonArrowRight } from "assets/icons/js/SvgButtonArrowRight";

import "./style.scss";
import useCheckEndsReached from "customHooks/useCheckEndsReached";

import "react-lazy-load-image-component/src/effects/blur.css";
import ViewPhoto from "components/ViewPhoto";
import clevertap from "clevertap-web-sdk";
import { useTheme } from "components/ListingNew/ListingTheme";

interface PageProps {
	guestImages: any;
	data: any;
}

const RealMemories = ({ guestImages, data }: PageProps) => {
	// console.log(data)
	// console.log(`https://ik.imagekit.io/5tgxhsqev/saffronstays-media/image/upload/${data?.images_list[0]}`);

	const listRef = useRef(null);
	const { reachedRight, reachedLeft } = useCheckEndsReached({
		ref: listRef,
	});

	const [openView, setOpenView] = useState(false);
	const [viewData, setviewData] = useState({
		img: "",
		video: "",
	});

	const theme = useTheme();

	return (
		<div className="realmemories-wrapper" onClick={() => {}}>
			<ViewPhoto
				open={openView}
				setOpen={setOpenView}
				img={viewData.img}
				video={viewData.video}
			/>
			<div className="listing__spotlight-arrows">
				<span
					className="button-one"
					//@ts-ignore
					onClick={() => {
						//@ts-ignore
						listRef.current.scrollLeft += -595;
						clevertap.event.push("real_moments_landingPage", {
							villaId: data?.listing_list?.id,
							villaName: data?.listing_list?.file_reference,
							time: new Date(),
						});
					}}
				>
					{reachedLeft ? (
						<SvgButtonArrowLeft
							rectFill={theme?.background}
							rectStroke={theme?.textButtonColor}
							pathFill={theme?.textButtonColor}
						/>
					) : (
						<SvgButtonArrowRight
							rectFill={theme?.background}
							rectStroke={theme?.textButtonColor}
							pathFill={theme?.textButtonColor}
							style={{ transform: "rotate(180deg)" }}
						/>
					)}
				</span>
				<span
					className="button-two"
					onClick={() => {
						//@ts-ignore
						listRef.current.scrollLeft += 590;
						clevertap.event.push("real_moments_landingPage", {
							villaId: data?.listing_list?.id,
							villaName: data?.listing_list?.file_reference,
							time: new Date(),
						});
					}}
				>
					{reachedRight ? (
						<SvgButtonArrowLeft
							rectFill={theme?.background}
							rectStroke={theme?.textButtonColor}
							pathFill={theme?.textButtonColor}
							style={{ transform: "rotate(180deg)" }}
						/>
					) : (
						<SvgButtonArrowRight
							rectFill={theme?.background}
							rectStroke={theme?.textButtonColor}
							pathFill={theme?.textButtonColor}
						/>
					)}
				</span>
			</div>
			<div className="guest-img-wrapper" ref={listRef}>
				{guestImages?.slice(0, 10)?.map((ele: any) => {
					return (
						<div
							className="guest-img-card"
							style={{
								background: theme?.background2,
								border: theme?.borderBookingBox,
							}}
						>
							{ele.TYPE === "image" ? (
								<LazyLoadImage
									onClick={() => {
										setviewData({
											img: ele.VISUAL_MEDIA.includes(
												"http://res.cloudinary.com/",
											)
												? ele.VISUAL_MEDIA
												: `https://ik.imagekit.io/5tgxhsqev/saffronstays-media/image/upload/${ele.VISUAL_MEDIA}?tr=w-500,h-auto,q-80,f-webp`,
											video: "",
										});
										setOpenView(true);
										clevertap.event.push("checked_real_moments", {
											villaId: data?.listing_list?.id,
											villaName: data?.listing_list?.file_reference,
											listing_page_urL: window.location.href,
											listing_page_image_url: `https://ik.imagekit.io/5tgxhsqev/saffronstays-media/image/upload/${data?.images_list[0]}`,
											real_moments_image_url: ele.VISUAL_MEDIA.includes(
												"http://res.cloudinary.com/",
											)
												? ele.VISUAL_MEDIA
												: `https://ik.imagekit.io/5tgxhsqev/saffronstays-media/image/upload/${ele.VISUAL_MEDIA}?tr=h-762,q-80`,
											time: new Date(),
										});
									}}
									effect={"blur"}
									src={
										ele.VISUAL_MEDIA.includes("http://res.cloudinary.com/")
											? ele.VISUAL_MEDIA
											: `https://ik.imagekit.io/5tgxhsqev/saffronstays-media/image/upload/${ele.VISUAL_MEDIA}?tr=h-auto,q-50,f-webp,w-500`
									}
									alt=""
								/>
							) : (
								<video
									src={
										ele.VISUAL_MEDIA.includes("http://res.cloudinary.com/")
											? ele.VISUAL_MEDIA
											: `https://ik.imagekit.io/5tgxhsqev/saffronstays-media/video/upload/${ele.VISUAL_MEDIA}?tr=h-762,q-50`
									}
									controls
								/>
							)}
							<span style={{ color: theme?.secondaryTextColor }}>
								{ele.GUEST_NAME || "Guest"} {ele.CREATED_ON && "•"}{" "}
								{ele.CREATED_ON &&
									new Date(ele.CREATED_ON).toDateString().slice(3)}
							</span>
						</div>
					);
				})}
				{guestImages?.length > 10 && (
					<div
						onClick={() => {
							window.location.href += "&photos=true&memories=true";
						}}
						className="guest-img-card"
					>
						<div className="view-more">View All</div>
					</div>
				)}
			</div>
		</div>
	);
};

export default RealMemories;
